
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 2c2.778 0 5.114 1.9 5.794 4.468C15.327 10.258 14.292 9 12 9s-3.327 1.258-5.794 1.468C6.886 7.9 9.222 6 12 6zm-5.975 6.72H7.2c2.209 0 3.556 1.421 3.556 3.631v1.56c-2.5-.452-4.503-2.691-4.731-5.191zm6.731 5.19v-1.56c0-2.21 1.835-3.631 4.044-3.631h1.175c-.228 2.501-2.219 4.74-5.219 5.191z","fill":"currentColor"}})])
          )
        }
      }
    